/**
 * Normalize API / system errors before showing them to shoppers.
 * Avoids exposing hosting vendor names in the UI.
 */
export function sanitizeUserFacingError(message, fallback = '') {
  if (message == null || message === '') return fallback;

  let text = String(message);

  const replacements = [
    [/https?:\/\/[^\s]*\.vercel\.app[^\s]*/gi, 'our servers'],
    [/[^\s]*\.vercel-storage\.com[^\s]*/gi, 'media storage'],
    [/set\s+REACT_APP_API_URL\s+in\s+vercel/gi, 'configure the API URL for this site'],
    [/on\s+the\s+vercel\s+backend\s+project[^.]*\.?/gi, 'Contact support if this continues.'],
    [/in\s+vercel\s*\([^)]*\)/gi, 'in server configuration'],
    [/for\s+vercel:\s*/gi, ''],
    [/check\s+vercel\s+logs[^.]*\.?/gi, 'Try again in a moment.'],
    [/see\s+vercel\s+logs[^.]*\.?/gi, 'Try again in a moment.'],
    [/vercel\s+function\s+logs/gi, 'server logs'],
    [/vercel\s+logs/gi, 'server logs'],
    [/vercel\s+backend/gi, 'backend'],
    [/\bon\s+vercel\b/gi, 'on the server'],
    [/\bvercel\b/gi, 'the server'],
  ];

  for (const [pattern, replacement] of replacements) {
    text = text.replace(pattern, replacement);
  }

  return text.replace(/\s{2,}/g, ' ').replace(/\s+([.,;:])/g, '$1').trim() || fallback;
}
